export const ErrCodeReportInProcess = 1;
export const ErrCodeVisitNotFound = 2;
export const ErrCodeReportNotFound = 3;
export const ErrCodeInvalidParameter = 4;
export const ErrCodeRequestTimeout = 5;
